export enum TRANSLATABLE_FILTER_VALUES {
  Online = "Online",
  Offline = "Offline",
  Inactive = "Inactive",
  DeactivatedVehicles = "deactivatedVehicles",
  Disabled = "Disabled",
  BreakOrRest = "BreakOrRest",
  Available = "Available",
  Work = "Work",
  Drive = "Drive",
  Undefined = "Undefined",
  Unknown = "Unknown",
  Unknown4 = "Unknown4",
  Unknown5 = "Unknown5",
  NotAvailable = "NotAvailable",
  NoDeviceImei = "noDeviceImei",
  NotReserved = "Not reserved",
  Overdue = "Overdue",
  Reserved = "Reserved",
  DueSoon = "DueSoon",
  NoDownloads = "NoDownloads",
  NoSchedules = "No schedules",
  AutomaticInitialDriverDownload = "Automatic initial Driver Download",
  AutomaticInitialVehicleDownload = "Automatic initial Vehicle Download",
  GlobalSchedule = "Global schedule",
  QuickSchedule = "Quick schedule",
  OnTime = "OnTime"
}

export enum FILTER_KEYS {
  CompanyIds = "CompanyIds",
  Date = "date",
  DateRangeFrom = "from",
  DateRangeTo = "to",
  DeactivatedVehicles = "DeactivatedVehicles",
  DriverIds = "driverIds",
  GlobalScheduleAssigned = "GlobalScheduleAssigned",
  NoDeviceImei = "NoDeviceImei",
  NoSchedulesAssigned = "NoSchedulesAssigned",
  NoVehicleImeiAssigned = "NoVehicleImeiAssigned",
  QuickScheduleAssigned = "QuickScheduleAssigned",
  ScheduleIds = "ScheduleIds",
  ScheduleNames = "ScheduleNames",
  VehicleIds = "vehicleIds",
  VehicleImeis = "VehicleImeis"
}

export enum FILTER_NAMES {
  Company = "Company",
  CreditStatuses = "CreditStatuses",
  DateRange = "dateRange",
  DateRangeFrom = "dateRangeFrom",
  DateRangeTo = "dateRangeTo",
  DeactivatedVehicles = "deactivatedVehicles",
  DownloadsAttempts = "downloadsattempts",
  DriverName = "driverName",
  Imei = "imei",
  LastDownload = "downloadStatuses",
  LastDownloadAttempt = "lastDownloadAttempt",
  NoDeviceImei = "noDeviceImei",
  Schedule = "schedule",
  Schedules = "schedules",
  Status = "status",
  Statuses = "statuses",
  VehicleNumber = "vehicleNumber"
}

export enum VALUE_IDS {
  Null = "null",
  True = "true",
  Quick = "quick",
  Global = "global"
}

export enum TRANSLATE_STRINGS {
  Filter = "Filter",
  General = "General",
  Table = "Table",
  LastDownloadFilter = "Filter##last download options"
}
